import {
	AddOn,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
} from "../../../../index";
import plutioProvider from "../../providers/prod/plutio";

const toolPreviewAsset =
	"/assets/add-ons/a009/plutio-header-generator-tool.svg";

const a009AddOn = new AddOn({
	internalId: "a009",
	externalId: "pro_01h7hs45rmjqh1xp5px7k1t29z",
	shortName: "Plutio Header Generator",
	longName: "Plutio Header Generator",
	shortDescription: "Generate task board header assets for Plutio",
	longDescription: "Generate task board header images directly inside Plutio. The tool lets you customize text, color, style, icon, and position, then preview, copy, download, and apply the image to a board column header.",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/icons/a009_icon_rounded.png"
	),
	coverAsset: Asset.image(toolPreviewAsset),
	previewAssets: [
		Asset.image(toolPreviewAsset),
	],
	docsUrl:
		"https://docs.version2.io/articles/assets-generator-bae920-829dc",
	providersIds: [
		plutioProvider._.id,
	],
	status: AddOnStatus.ACTIVE,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a009_p001",
			externalId: "pri_01h7hs55dawp35trjx8nx15apg",
			prices: [new Price({ currency: Currency.USD, amount: 0 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a009_p002",
			externalId: "pri_01h7hs4ng92a2c8134qy5fgwf2",
			prices: [new Price({ currency: Currency.USD, amount: 0 })],
		}),
	],
	usageStats: [
	],
	settingsConfig: [],
	highlightFeatures: [
		new HighlightFeature({
			title: "Customize to your liking",
			description:
				"You can customize the headers to your liking, you can change the color, the text, the icon and the position of the header.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
		}),
		new HighlightFeature({
			title: "Live preview",
			description: "You can see the preview of the header before generating it.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
		}),
		new HighlightFeature({
			title: "Full privacy",
			description:
				"All the images are generated on your device, no data is sent to the cloud.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/safety.svg",
		}),
	],
});

export default a009AddOn;
